import { render } from "./SelecaoDebitoVeicular.vue?vue&type=template&id=f2a9c2d6"
import script from "./SelecaoDebitoVeicular.vue?vue&type=script&lang=js"
export * from "./SelecaoDebitoVeicular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__